import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ExternalLink } from '../../../common/ExternalLink'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText } from '../../../helpers/value'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import classes from './index.module.scss'

export const Macroeconomic = ({ data, detailKey }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const detailData = data[detailKey]

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        {detailData?.event && (
          <Element className="dFlex alignItemsCenter">
            <Translate value="alertDetail.EVENT" className="fw600" />
            :&nbsp;
            {formatText(detailData?.event)}
          </Element>
        )}
        <Element className="dFlex alignItemsCenter">
          <Translate value="alertDetail.SOURCE" className="fw600" />
          :&nbsp;
          <span>{formatText(detailData?.source)}</span>
        </Element>
        <div>
          <Translate value="alertDetail.PUBLICATION_DATE" className="fw600" />
          :&nbsp;
          <span>
            {formatDateTime(
              detailData?.publicDate,
              FORMAT.DATE,
              locale,
              timezone,
            )}
          </span>
        </div>
        {detailData?.contents && (
          <div
            className="mt1"
            dangerouslySetInnerHTML={{ __html: detailData?.contents }}
          />
        )}
        <div className="textEnd mt1">
          <ExternalLink href={detailData?.sourceLink}>
            <Translate value="alertDetail.LINK_ARTICLE" />
          </ExternalLink>
        </div>
      </Element>
    </Panel>
  )
}
